import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import BaseValidator from './BaseValidator'
import { AttributionDetails } from '../components/ApplicationForm/types'
import { KnownSource } from '../types/Source'

const minLoanAmountPerSource: Partial<{ [key in KnownSource]: number }> = {
  autotrader: 1000
}

const LoanAmountValidator = ({ source }: Partial<AttributionDetails>): BaseValidator & { validationMessage: string } => {
  const minLoanAmount = source
    ? minLoanAmountPerSource[source] ?? 2000
    : 2000

  const validationMessage = `Please enter a value between £${minLoanAmount} and £100,000`

  const schema = yup.object().shape({
    loanValue: yup.number()
      .typeError(validationMessage)
      .min(minLoanAmount, validationMessage)
      .max(100_000, validationMessage)
      .required(validationMessage)
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      loanValue: state.loanAmount
    }),
    validationMessage
  }
}

export default LoanAmountValidator
